export const GET_PRODUCT_TYPE_DEF= "GET_PRODUCT_TYPE_DEF"
export const GET_PRODUCT_TYPE_DEF_SUCCESS = "GET_PRODUCT_TYPE_DEF_SUCCESS"
export const GET_PRODUCT_TYPE_DEF_FAIL = "GET_PRODUCT_TYPE_DEF_FAIL"

export const PRODUCT_TYPE_DEF_API_ERROR = "API_ERROR"